import { flushSync } from "react-dom";
import UserNotification from "util/UserNotification";
import { loadDashboardWithSearch } from "views/logic/views/Actions";
import { setIsDirty, setIsNew } from "views/logic/slices/viewSlice";
import { createView } from "views/api/views";
export default (view, history, entityShare, existingViewId, search) => async (dispatch) => {
  try {
    const savedView = await createView(view, entityShare, existingViewId);
    flushSync(() => {
      dispatch(setIsDirty(false));
      dispatch(setIsNew(false));
    });
    loadDashboardWithSearch(history, savedView.id, search);
    UserNotification.success(`Saving view "${view.title}" was successful!`, "Success!");
  } catch (error) {
    UserNotification.error(`Saving view failed: ${error}`, "Error!");
  }
};
